/** Canonical query / OS window param names for agentic v2 deep links. */
export const NAV_KEYS = {
  taskId: "taskId",
  /** Read-only alias for legacy share links; never written on serialize. */
  taskLegacy: "task",
  focus: "focus",
  focusSeq: "focusSeq",
  view: "view",
  tab: "tab",
  visibility: "visibility",
  taskBucket: "taskBucket",
  asUserId: "asUserId",
  conversation: "conversation",
  /** Read-only alias; never written on serialize. */
  conversationLegacy: "conversationId",
  mode: "mode",
  event: "event",
  /** Calculators app — which mini-calculator is open */
  calculatorId: "calculatorId",
  /** Household context for client-scoped calculators */
  faClientId: "faClientId",
} as const;

export type NavKey = (typeof NAV_KEYS)[keyof typeof NAV_KEYS];
